import {
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";

export const useSequentialAnimals = () => {
  const animals = useAllValidAnimals();
  const animal = useCurrentAnimal();

  const currentAnimalIndex = animals.findIndex((a) => a.id === animal.id);
  const nextAnimalId = animals[currentAnimalIndex + 1]?.id;

  return {
    currentAnimalIndex,
    nextAnimalId,
  };
};
